module.exports = __webpack_public_path__ + "img/salon-home.png";